export * from '../src/composites/wui-tabs/index.js';
//# sourceMappingURL=wui-tabs.js.map